import { HttpClient } from '@angular/common/http';
import { environment } from '@app/environment';
import { map } from 'rxjs/operators';
import type { RemotePage } from '../core/data/remote-pages';
import { ApiCompanyPublication } from './api-result.model';
import { CompanyPublication, toPublication } from './company.model';

/** One page of the publications of a company, as the backend pages them. */
export const fetchPublications = (
  http: HttpClient,
  companyId: string,
  page: number,
  resultsPerPage: number
) =>
  http
    .post<RemotePage<ApiCompanyPublication>>(
      `${environment.apiBase}/fetchPublication`,
      {
        method: 'fetchPublication',
        data: { companyId, page, resultsPerPage },
      }
    )
    .pipe(
      map(
        ({ totalCount, data }): RemotePage<CompanyPublication> => ({
          totalCount,
          data: data.map(toPublication),
        })
      )
    );
